import {SelectProps} from '../components/select';

export const getSelect =
  <T>(data: Omit<SelectProps<T>, 'type'>) =>
  (): SelectProps<T> => ({
    ...data,
    type: 'select',
  });
